import Feature from "ol/Feature";
import { Vector } from "ol/source";

import type { Layer } from "ol/layer";

const getMaxZIndex = (layer: Layer<Vector>): number => {
  if (!layer || !layer.getSource()) {
    return 0;
  }
  const features = layer.getSource().getFeatures();
  if (!features || features.length === 0) {
    return 0;
  }
  const zIndexes = features.map((feature: Feature) => {
    return feature.get("zIndex") || 0;
  });
  return Math.max(...zIndexes);
};
export default getMaxZIndex;
